module.exports = __webpack_public_path__ + "static/media/timelapse_30.a988d76e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_30.jpg
// module id = 988
// module chunks = 0